// extracted by mini-css-extract-plugin
export default {"navbar":"registerpin_navbar__L2xAR","formContainer":"registerpin_formContainer__AJO6+","submit":"registerpin_submit__qqCIB"};